type SpinnerProps = {
  extraClassName?: string
}
export const Spinner = ({ extraClassName: extraClassName }: SpinnerProps) => {
  const className = `spinner-container ${extraClassName}`

  return (
    <div className={className}>
      <div className="spinner" />
    </div>
  )
}

export const OptionSpinner = () => {
  return (
    <div className="option-spinner-container">
      <div className="spinner" />
    </div>
  )
}
